import React from 'react'
import { Drawer } from "@measured/puck";
import landingImage1 from '../images/landing-page-1.png';
import landingImage2 from '../images/landing-page-2.png';
import landingImage3 from '../images/landing-page-3.jpg';
import formPage1 from '../images/card-screen-1.jpg';
import formPage2 from '../images/card-screen-2.jpg';
import formSingle from '../images/form-single.jpg';
import formWizard from '../images/form-wizard.jpg';
import reportPage from '../images/report-page.jpg';
import reportCard from '../images/report-card.jpg';
import reportResult from '../images/report-total.jpg';
import reportChart from '../images/chartcard.jpg';
import reportDownload from '../images/card-download.jpg';
import reportSingleImage from '../images/report-single.jpg';
import ReportTableImg from '../images/report-single-table.jpg';
import HeaderTransparentImage from '../images/header-transparent.jpg';
import HeaderWhiteImage from '../images/header-white.jpg';
import InputTextFieldImage from '../images/text-field.jpg';
import TextareaFieldImage from '../images/textarea-field.jpg';
import DropdownImage from '../images/dropdown-field.jpg';
import CheckboxImage from '../images/check-field.jpg';
import RadioImage from '../images/radio-field.jpg';
import PhoneNumberImage from '../images/phone-number-field.jpg';
import NumberImage from '../images/number-field.jpg';
import EmailImage from '../images/email-field.jpg';
import DateImage from '../images/date-field.jpg';
import RangeImage from '../images/range.jpg';
import ToggleImage from '../images/switch-field.jpg';
import ButtonImage from '../images/button.jpg';
import ReportCardSectionsImg from '../images/report-card-posts.jpg';
import DownloadReportThankYouImg from '../images/download-thankyou.jpg';
import Logo from '../images/Logo';

import ColumnsImage from '../images/columns.jpg';
import SpacingImage from '../images/spacing.jpg';
import HeadingImage from '../images/heading.jpg';
import TextImage from '../images/paragraph.jpg';
import ImageImage from '../images/image.jpg';
import WrapperImage from '../images/section.jpg';
import TransparentSectionImage from '../images/plain-bg.jpg';
import GradientSectionImage from '../images/gradient-bg.jpg';
import ToggleSwitchImage from '../images/toggle-switch.jpg';
import CollapsibleImage from '../images/collapsible.jpg';
import NavBarImage from '../images/navbar.png';
import ResultsNavBarImage from '../images/report-navbar.png';
import ModalImage from '../images/dialog.png';
import ProgressImage from '../images/progressbar.png';

export default function DrawerROI() {
    return (
        <>
            <div className="sidebar-wrapper">
                {/**Headers**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHeader" aria-expanded="false" aria-controls="collapseHeader">
                        Header
                    </button>

                    <div className="collapse show" id="collapseHeader">
                        <div className="row gx-12px">

                            <div className="col-6">
                                <Drawer.Item name="PageHeader" index={3}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={NavBarImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Header</div>

                                        </div>
                                    }
                                </Drawer.Item>
                            </div>


                            <div className="col-6">
                                <Drawer.Item name="ResultsPageHeader" index={3}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={ResultsNavBarImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Results Header</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>


                        </div>
                    </div>
                </div>
                {/**Banners **/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBanner" aria-expanded="false" aria-controls="collapseBanner">
                        Banner
                    </button>

                    <div className="collapse show" id="collapseBanner">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="BannerLeftTextRightImage" index={0}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={landingImage2} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="BannerCenterText" index={1}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={landingImage3} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                        </div>
                    </div>
                </div>
                {/** Cards **/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCards" aria-expanded="false" aria-controls="collapseCards">
                        Cards
                    </button>
                    <div className="collapse show" id="collapseCards">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="CardLayout1" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={formPage1} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="CardLayout2" index={3}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={formPage2} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                        </div>
                    </div>
                </div>
                {/**Forms**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseForm" aria-expanded="false" aria-controls="collapseForm">
                        Form
                    </button>
                    <div className="collapse show" id="collapseForm">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="SinglePage" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={formSingle} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="WizardForm" index={3}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={formWizard} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                        </div>
                    </div>
                </div>
                {/**Form Fields**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFormFields" aria-expanded="false" aria-controls="collapseFormFields">
                        Form Fields
                    </button>

                    <div className="collapse show" id="collapseFormFields">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="FormNav" index={1}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={InputTextFieldImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Navigation</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="FormNav2" index={1}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={InputTextFieldImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Form Navigation</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="InputTextField" index={1}>
                                    {() =>
                                        <>

                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={InputTextFieldImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Text</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="InputNumberField" index={1}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={NumberImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Numeric</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="TextareaField" index={2}>
                                    {() =>
                                        <>
                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={TextareaFieldImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Multi-line text</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Dropdown" index={3}>
                                    {() =>
                                        <>
                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={DropdownImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Dropdown</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="PhoneNumber" index={4}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={PhoneNumberImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Phone</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Email" index={5}>
                                    {() =>
                                        <>
                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={EmailImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Email</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Checkbox" index={5}>
                                    {() =>
                                        <>
                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={CheckboxImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Checkbox</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Radio" index={5}>
                                    {() =>
                                        <>
                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={RadioImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Radio buttons</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>

                            <div className="col-6">
                                <Drawer.Item name="Date" index={5}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={DateImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Date</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Range" index={5}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={RangeImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Range Slider</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div> <div className="col-6">
                                <Drawer.Item name="ProgressBar" index={5}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={ProgressImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Progress Bar</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Toggle" index={5}>
                                    {() =>
                                        <>
                                            <div className="field-in">
                                                <div className='left-item'>
                                                    <img src={ToggleImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Toggle button</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>


                            <div className="col-6">
                                <Drawer.Item name="Button" index={6}>
                                    {() =>
                                        <>
                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={ButtonImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Button</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>


                            <div className="col-6">
                                <Drawer.Item name="BootstrapModal" index={6}>
                                    {() =>
                                        <>
                                            <div className="field-in">

                                                <div className='left-item'>
                                                    <img src={ModalImage} className='img-fluid' alt="Section" />
                                                </div>
                                                <div className='field-name'>Modal</div>
                                            </div>
                                        </>
                                    }
                                </Drawer.Item>
                            </div>


                        </div>
                    </div>
                </div>
                {/**Report**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReport" aria-expanded="false" aria-controls="collapseReport">
                        Report
                    </button>

                    <div className="collapse show" id="collapseReport">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="ReportPage" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportPage} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="CardSection" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportCard} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="ResultCard" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportResult} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="ChartCard" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportChart} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadCard" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportDownload} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                        </div>
                    </div>
                </div>
                {/**Report Single**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReportSingle" aria-expanded="false" aria-controls="collapseReportSingle">
                        ReportSingle
                    </button>

                    <div className="collapse show" id="collapseReportSingle">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="ReportSection" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportSingleImage} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="ReportTable" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={ReportTableImg} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                        </div>
                    </div>
                </div>

                {/**Report Portrait**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReportPortrait"
                        aria-expanded="false" aria-controls="collapseReportPortrait">
                        Portrait Report Banner
                    </button>

                    <div className="collapse show" id="collapseReportPortrait">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="DownloadReportBanner" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportSingleImage} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                        </div>
                    </div>
                </div>
                {/**Download Portrait Report**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReport" aria-expanded="false" aria-controls="collapseReport">
                        Portrait Report Page
                    </button>

                    <div className="collapse show" id="collapseReport">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="DownloadReportPage" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportPage} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadCardSection" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportCard} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadResultCard" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportResult} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadChartCard" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportChart} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadDownloadCard" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportDownload} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                        </div>
                    </div>
                </div>

                {/**Download Report Single**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDownloadReportSingle" aria-expanded="false" aria-controls="collapseDownloadReportSingle">
                        Download Report Single
                    </button>

                    <div className="collapse show" id="collapseDownloadReportSingle">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="DownloadReportSection" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={reportSingleImage} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadReportTable" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={ReportTableImg} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadReportCardsSection" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={ReportCardSectionsImg} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="DownloadReportThankYou" index={2}>
                                    {() =>
                                        <div className="field-in">

                                            <div className='left-item'>
                                                <img src={DownloadReportThankYouImg} className='img-fluid' alt="Section" />
                                            </div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                        </div>
                    </div>
                </div>

                {/**Section Individual Components**/}
                <div className="component-type">
                    <button className="heading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSectionComp" aria-expanded="false" aria-controls="collapseSectionComp">
                        Section Components
                    </button>

                    <div className="collapse show" id="collapseSectionComp">
                        <div className="row gx-12px">
                            <div className="col-6">
                                <Drawer.Item name="TransparentSection" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={TransparentSectionImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Transparent Section</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="GradientSection" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={GradientSectionImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Gradient Section</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Columns" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={ColumnsImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Columns</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Wrapper" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={WrapperImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Wrapper</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Spacing" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={SpacingImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Spacing</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Separator" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={SpacingImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Separator</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Heading" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={HeadingImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Heading</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                            <div className="col-6">
                                <Drawer.Item name="Text" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={TextImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Text</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Image" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={ImageImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Image</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="IconUploader" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={ImageImage} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Icon</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                            <div className="col-6">
                                <Drawer.Item name="RedCards" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={formPage1} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Cards Layout 1</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="WhiteCards" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={formPage2} className='img-fluid' alt="Section" />
                                            </div>
                                            <div className='field-name'>Cards Layout 2</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                            <div className="col-6">
                                <Drawer.Item name="eCharts" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={reportChart} className='img-fluid' alt="eCharts" />
                                            </div>
                                            <div className='field-name'>eCharts</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>

                            <div className="col-6">
                                <Drawer.Item name="ToggleSwitch" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={ToggleSwitchImage} className='img-fluid' alt="eCharts" />
                                            </div>
                                            <div className='field-name'>Toggle switch</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>
                            <div className="col-6">
                                <Drawer.Item name="Collapsible2" index={1}>
                                    {() =>
                                        <div className="field-in">
                                            <div className='left-item'>
                                                <img src={CollapsibleImage} className='img-fluid' alt="eCharts" />
                                            </div>
                                            <div className='field-name'>Collapsible</div>
                                        </div>
                                    }
                                </Drawer.Item>
                            </div>


                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
